import { render, staticRenderFns } from "./AllContributions.vue?vue&type=template&id=2820fad2&"
import script from "./AllContributions.vue?vue&type=script&lang=js&"
export * from "./AllContributions.vue?vue&type=script&lang=js&"
import style0 from "./AllContributions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports